import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-oauthcred',
  templateUrl: './oauthcred.component.html',
  styleUrls: ['./oauthcred.component.scss']
})
export class OauthcredComponent implements OnInit {
  oauthList: any = [];
  showSBDAdminTab: boolean = false;
  addOAuthapierror: boolean = false;
  noerrorinadd: boolean = false;
  deleteOAuthapierror: boolean = false;
  updateOAuthapierror: boolean = false;
  errorrealm: boolean = false;
  errorname: boolean = false;
  errornamepresent: boolean = false;
  errorclientIDadd: boolean = false;
  errorclientSecretadd: boolean = false;
  errortokenUrladd: boolean = false;
  errorrealmlen: boolean = false;
  errorclientIDaddlen: boolean = false;
  errorclientSecretaddlen: boolean = false;
  errortokenUrladdlen: boolean = false;
  noerrorinupdate: boolean = false;
  errorrealmupdate: boolean = false;
  errorclientIDupdate: boolean = false;
  errorclientSecretupdate: boolean = false;
  errortokenUrlupdate: boolean = false;
  errorrealmupdatelen: boolean = false;
  errorclientIDupdatelen: boolean = false;
  errorclientSecretupdatelen: boolean = false;
  errortokenUrlupdatelen: boolean = false;
  validtokeninadd: boolean = false;
  validtokeninup: boolean = false;
  isBackToTopShowBtn: boolean = false;
  type: any = "global"
  clientIDIn: any;
  clientSecretIn: any;
  nameIn: any;
  serviceroles: any = [];
  cerdnamesList: any = [];
  inTokenUrl: any;
  inClientSecret: any;
  inClientID: any;
  deleteoauthid: any;
  oauthListid: any;
  oauthListname: any;
  oauthListclientID: any;
  oauthListclientSecret: any;
  oauthListtokenUrl: any;
  oauthListrealm: any;
  oauthListidadd: any;
  oauthListnameadd: any;
  oauthListclientIDadd: any;
  oauthListclientSecretadd: any;
  oauthListtokenUrladd: any;
  oauthListrealmadd: any;

  constructor(private service: ApifirstService, private modalService: NgbModal, private route: Router) { }
  ngOnInit(): void {
    this.oauthListnameadd = "pleaseSelect";
    this.service.showSBDAdminTab.subscribe((data) => {
      this.showSBDAdminTab = data
      if (this.showSBDAdminTab == true) {
        this.type = "global"
      }
    })
    this.service.getOAuth(this.type).subscribe((data) => {
      this.oauthList = data
      this.cerdnamesList = []
      for (let outh of this.oauthList) {
        this.cerdnamesList.push(outh.name);
      }
    })
    this.service.getOAuthServiceRole().subscribe((data) => {
      this.serviceroles = data
    })
  }
  /*on click of add button*/
  addOauth(addOauthCredentials: any) {
    this.modalService.open(addOauthCredentials, { centered: true });
    this.errorrealm = false;
    this.errorname = false;
    this.errorclientIDadd = false;
    this.errornamepresent = false;
    this.errorclientSecretadd = false;
    this.errortokenUrladd = false;
    this.errorrealmlen = false;
    this.errorclientIDaddlen = false;
    this.errorclientSecretaddlen = false;
    this.errortokenUrladdlen = false;
    this.oauthListclientIDadd = '';
    this.oauthListrealmadd = '';
    this.oauthListnameadd = "pleaseSelect";
    this.oauthListclientSecretadd = '';
    this.oauthListtokenUrladd = '';
  }
  /*on click of submit button in add popup*/
  setsubmitupdateoauthAdd(oauthListnameadd: any, oauthListrealmadd: any, oauthListclientIDadd: any, oauthListclientSecretadd: any,
    oauthListtokenUrladd: any) {
    this.validtokeninadd = false;
    this.errorname = false;
    this.errorrealm = false;
    this.errorclientIDadd = false;
    this.errornamepresent = false;
    this.errorclientSecretadd = false;
    this.errortokenUrladd = false;
    this.errorrealmlen = false;
    this.errorclientIDaddlen = false;
    this.errorclientSecretaddlen = false;
    this.errortokenUrladdlen = false;
    if (oauthListnameadd == "pleaseSelect") {
      this.errorname = true;
    }
    else {
      this.errorname = false;
      if (this.cerdnamesList.includes(oauthListnameadd)) {
        this.errornamepresent = true;
      }
      else {
        this.errornamepresent = false;
      }
    }

    if (oauthListrealmadd == null || oauthListrealmadd == undefined || oauthListrealmadd == '' ||
      oauthListrealmadd.length === 0) {
      this.errorrealm = true;
    }
    else {
      this.errorrealm = false;
    }
    if (oauthListrealmadd.length > 255) {
      this.errorrealmlen = true;
    }
    else {
      this.errorrealmlen = false;
    }
    if (oauthListclientIDadd == null || oauthListclientIDadd == undefined || oauthListclientIDadd == '' ||
      oauthListclientIDadd.length === 0) {
      this.errorclientIDadd = true;
    }
    else {
      this.errorclientIDadd = false;
    }
    if (oauthListclientIDadd.length > 255) {
      this.errorclientIDaddlen = true;
    }
    else {
      this.errorclientIDaddlen = false;
    }
    if (oauthListclientSecretadd == null || oauthListclientSecretadd == undefined || oauthListclientSecretadd == '' ||
      oauthListclientSecretadd.length === 0) {
      this.errorclientSecretadd = true;
    }
    else {
      this.errorclientSecretadd = false;
    }
    if (oauthListclientSecretadd.length > 255) {
      this.errorclientSecretaddlen = true;
    }
    else {
      this.errorclientSecretaddlen = false;
    }
    if (oauthListtokenUrladd == null || oauthListtokenUrladd == undefined || oauthListtokenUrladd == '' ||
      oauthListtokenUrladd.length === 0) {
      this.errortokenUrladd = true;
    }
    else {
      this.errortokenUrladd = false;
      this.validtokeninadd = !(this.validURL(oauthListtokenUrladd));
    }
    if (oauthListtokenUrladd.length > 255) {
      this.errortokenUrladdlen = true;
    }
    else {
      this.errortokenUrladdlen = false;
    }



    if (this.errorname == false && this.errornamepresent == false && this.errorrealm == false &&
      this.errorclientIDadd == false && this.errorclientSecretadd == false && this.errortokenUrladd == false &&
      this.errorrealmlen == false && this.errorclientIDaddlen == false && this.errorclientSecretaddlen == false &&
      this.errortokenUrladdlen == false) {
      this.noerrorinadd = true;
    }
    else {
      this.noerrorinadd = false;
    }
    let req = {
      "clientID": oauthListclientIDadd,
      "clientSecret": oauthListclientSecretadd,
      "global": true,
      "name": oauthListnameadd,
      "oauthType": oauthListrealmadd,
      "tockenURL": oauthListtokenUrladd
    }
    if (this.noerrorinadd == true) {
      this.service.addOAuth(req).subscribe((data) => {
        this.addOAuthapierror = false;
        this.service.getOAuth(this.type).subscribe((data) => {
          this.oauthList = data
          this.cerdnamesList = []
          for (let outh of this.oauthList) {
            this.cerdnamesList.push(outh.name);
          }
        })
        this.service.getOAuthServiceRole().subscribe((data) => {
          this.serviceroles = data
        })
        this.modalService.dismissAll(true);
      }, (error) => {
        this.addOAuthapierror = true;
      });
    }
  }
  validURL(str: any) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }
/*on click of properties button*/
    properties(id: any,name :any, type: any, clientID: any, clientSecret: any, tockenURL: any, oauth_realm_id: any) {
      this.service.getProperty(oauth_realm_id).subscribe((data)=> {
        this.service.propertyData.next(data)
  
      })
      this.service.IDpropertyData.next(oauth_realm_id)
      this.route.navigateByUrl('/admin/oauthProperties')
    }
  /*on click of delete buton*/
  deleteOAuthdata(id: any, deletePopUpOauth: any) {
    this.modalService.open(deletePopUpOauth, { centered: true });
    this.deleteoauthid = id;
  }
  /*on click of delete button in delete popup*/
  deletePopcredential() {
    let req = {
      "id": this.deleteoauthid,
    }
    this.service.deleteOAuth(req).subscribe((data) => {
      this.deleteOAuthapierror = false;
      this.service.getOAuth(this.type).subscribe((data) => {
        this.oauthList = data
        this.cerdnamesList = []
        for (let outh of this.oauthList) {
          this.cerdnamesList.push(outh.name);
        }
      })
      this.service.getOAuthServiceRole().subscribe((data) => {
        this.serviceroles = data
      })
    }, (error) => {
      this.deleteOAuthapierror = true;
    });
  }
  /*on click of update button*/
  updateOAuthdata(id: any, name: any, oauthType: any,
    clientID: any, clientSecret: any, tockenURL: any, updateOauthCredentials: any) {
    this.modalService.open(updateOauthCredentials, { centered: true });
    this.oauthListid = id;
    this.oauthListclientID = clientID;
    this.oauthListname = name;
    this.oauthListclientSecret = clientSecret;
    this.oauthListrealm = oauthType;
    this.oauthListtokenUrl = tockenURL;
  }
  /*on click of submit button in update popup*/
  setsubmitupdateoauthUpdate(oauthListrealm: any, oauthListclientID: any,
    oauthListclientSecret: any, oauthListtokenUrl: any) {
    this.validtokeninup = false;
    this.errorrealmupdate = false;
    this.errorclientIDupdate = false;
    this.errorclientSecretupdate = false;
    this.errortokenUrlupdate = false;
    this.errorrealmupdatelen = false;
    this.errorclientIDupdatelen = false;
    this.errorclientSecretupdatelen = false;
    this.errortokenUrlupdatelen = false;
    if (oauthListrealm == null || oauthListrealm == undefined || oauthListrealm == '' ||
      oauthListrealm.length === 0) {
      this.errorrealmupdate = true;
    }
    else {
      this.errorrealmupdate = false;
    }
    if (oauthListrealm.length > 255) {
      this.errorrealmupdatelen = true;
    }
    else {
      this.errorrealmupdatelen = false;
    }
    if (oauthListclientID == null || oauthListclientID == undefined || oauthListclientID == '' ||
      oauthListclientID.length === 0) {
      this.errorclientIDupdate = true;
    }
    else {
      this.errorclientIDupdate = false;
    }
    if (oauthListclientID.length > 255) {
      this.errorclientIDupdatelen = true;
    }
    else {
      this.errorclientIDupdatelen = false;
    }
    if (oauthListclientSecret == null || oauthListclientSecret == undefined || oauthListclientSecret == '' ||
      oauthListclientSecret.length === 0) {
      this.errorclientSecretupdate = true;
    }
    else {
      this.errorclientSecretupdate = false;
    }
    if (oauthListclientSecret.length > 255) {
      this.errorclientSecretupdatelen = true;
    }
    else {
      this.errorclientSecretupdatelen = false;
    }
    if (oauthListtokenUrl == null || oauthListtokenUrl == undefined || oauthListtokenUrl == '' ||
      oauthListtokenUrl.length === 0) {
      this.errortokenUrlupdate = true;
    }
    else {
      this.errortokenUrlupdate = false;
      this.validtokeninup = !(this.validURL(oauthListtokenUrl));
    }
    if (oauthListtokenUrl.length > 255) {
      this.errortokenUrlupdatelen = true;
    }

    else {
      this.errortokenUrlupdatelen = false;
    }
    if (this.errorrealmupdate == false && this.errorclientIDupdate == false &&
      this.errorclientSecretupdate == false && this.errortokenUrlupdate == false &&
      this.errorrealmupdatelen == false && this.errorclientIDupdatelen == false &&
      this.errorclientSecretupdatelen == false && this.errortokenUrlupdatelen == false) {
      this.noerrorinupdate = true;
    }
    else {
      this.noerrorinupdate = false;
    }
    let req = {
      "clientID": oauthListclientID,
      "clientSecret": oauthListclientSecret,
      "global": true,
      "id": this.oauthListid,
      "name": this.oauthListname,
      "oauthType": oauthListrealm,
      "tockenURL": oauthListtokenUrl
    }
    if (this.noerrorinupdate == true) {
      this.service.updateOAuth(req).subscribe((data) => {
        this.updateOAuthapierror = false;
        this.service.getOAuth(this.type).subscribe((data) => {
          this.oauthList = data
          this.cerdnamesList = []
          for (let outh of this.oauthList) {
            this.cerdnamesList.push(outh.name);
          }
        })
        this.service.getOAuthServiceRole().subscribe((data) => {
          this.serviceroles = data
        })
        this.modalService.dismissAll(true);
      }, (error) => {
        this.updateOAuthapierror = true;
      });
    }
  }
  clearVariables() {
    this.addOAuthapierror = false;
    this.noerrorinadd = false;
    this.deleteOAuthapierror = false;
    this.updateOAuthapierror = false;
    this.errorrealm = false;
    this.errorname = false;
    this.errorclientIDadd = false;
    this.errornamepresent = false;
    this.errorclientSecretadd = false;
    this.errortokenUrladd = false;
    this.errorrealmlen = false;
    this.errorclientIDaddlen = false;
    this.errorclientSecretaddlen = false;
    this.errortokenUrladdlen = false;
    this.noerrorinupdate = false;
    this.errorrealmupdate = false;
    this.errorclientIDupdate = false;
    this.errorclientSecretupdate = false;
    this.errortokenUrlupdate = false;
    this.errorrealmupdatelen = false;
    this.errorclientIDupdatelen = false;
    this.errorclientSecretupdatelen = false;
    this.errortokenUrlupdatelen = false;
    this.validtokeninup = false;
    this.validtokeninadd = false;
  }
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.isBackToTopShowBtn = true;
    } else {
      this.isBackToTopShowBtn = false;
    }
  }
}
